<template>
  <div class="wrap">
    <p class="description">
      Your record per category as if you played against everyone in your league
      the same week.
    </p>
     <div class="setting">
          <label for="checkBoxRank">
            <p>Show ranks</p>
            <input type="checkbox" id="checkBoxRank" v-model="showRank" />
          </label>
        </div>
    <div class="table-wrap">
      <div class="fl-table" v-if="viewChosen">
        <div class="fl-row header-row">
          <div class="fl-row-inner">
            <table-cell>
              <h3 class="h6"></h3>
            </table-cell>
            <table-cell
              v-for="(category, i) in categoryStrength.columns"
              v-bind:key="i"
              class="fl-cell"
            >
              <h3 class="h6">{{ category.display_name }}</h3>
            </table-cell>
          </div>
        </div>
        <div class="table-content">
          <div
            v-for="(row, i) in categoryStrength.rows"
            v-bind:key="i"
            class="fl-row"
            :class="[row.week == 0 ? 'highlight' : '']"
          >
            <div class="fl-row-inner">
              <table-cell>
                <p>
                  {{ row.week != 0 ? "Week " + row.week : "Season Record" }}
                </p>
              </table-cell>
              <table-cell
                v-for="(score, j) in row.scores"
                v-bind:key="j"
                class="fl-cell"
                :class="{
                  victory: score.wins > score.losses,
                  defeat: score.losses > score.wins,
                  tie: score.wins === score.losses,
                }"
                :value="
                  score.ties > 0
                    ? score.wins + '-' + score.losses + '-' + score.ties
                    : score.wins + '-' + score.losses
                "
                :rank="score.rank"
                :showRank="showRank"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableCell from "@/components/cell/cell.vue";

export default {
  name: "category",
  data() {
    return {
      categoryStrength: {},
      catagoryRequest: false,
      showRank: false,
    };
  },
  components: {
    "table-cell": tableCell,
  },
  props: ["leagues", "selectedLeague", "loaded", "leagueName", "refreshLeague"],
  computed: {
    viewChosen: function () {
      return this.leagueName && this.catagoryRequest;
    },
  },
  created: function () {
    if (this.selectedLeague.yahoo_object.league_key) {
      this.selectCategory();
    }
  },
  methods: {
    selectCategory: async function () {
      try {
        this.$store.dispatch("isLoading", true);
        this.categoryStrength = await this.$store.state.apiService.getCategoryWins(
          this.selectedLeague.yahoo_object.league_key
        );
      } catch (e) {
        if (e.response && e.response.status && e.response.status === 403) {
          this.$store.dispatch("login", true);
        }
      } finally {
        this.$store.dispatch("isLoading", false);
        this.catagoryRequest = true;
      }
    },
    ordinal: function (num) {
      let ending;
      switch (num) {
        case 1:
          ending = "st";
          break;
        case 2:
          ending = "nd";
          break;
        case 3:
          ending = "rd";
          break;
        default:
          ending = "th";
          break;
      }
      return ending;
    },
  },
  watch: {
    leagueName: function () {
      this.selectCategory();
    },
    refreshLeague: function () {
      this.selectCategory();
    },
  },
};
</script>

<style src="./category.styl" lang="stylus" scoped></style>
